import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useParams } from "react-router-dom";
import api from "../utils/intercepter/axiosConfig.js";
import { useNavigate } from "react-router-dom";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { FaArrowDown } from "react-icons/fa";

const TrEnregistrement = () => {

       const {w_id} = useParams();
       const [montant, setMontant] = useState(0);
       const [num_tr_code, setNumTrCode] = useState(0);
   
       const {state} = useLocation();
   
       const id_vente = state?.id_vente;
       console.log("num_vente : ", id_vente);
   
       const navigate = useNavigate();
       
       const fetchTrEnregistrementByWId = async () => {
           try {
               const response = await api.post("/auth/getTrEnregistrOfMutation",{
                   w_id: w_id
               });
               
               if(response.data.status){
                   setMontant(response.data.response.montant)
                   setNumTrCode(response.data.response.num_tr);
               }
               else{
                   console.log("Aucun TF Enregistrement")
               }
           } catch (error) {
               console.log("Erreur Connexion")
           }
       }
   
       useEffect(() => {
   
           if(w_id){
   
              fetchTrEnregistrementByWId();
   
           }
       }, [w_id])
       
     return (
       <div className="container mt-5">
         <h2 className="mb-4 text-center">TR Enregistrement</h2>
   
         <div className="card">
           <div className="card-body">
           
           <table className="table table-bordered">
   
                       <tbody>
                           <tr>
                           <td className="text-start">
                               Montant
                               </td>
                              <td>
                               {montant ? montant.toLocaleString() : "N/A"} MRU
                               </td> 
                           </tr>
   
                           <tr>
                           <td className="text-start">
                           Code
                               </td>
                              <td>
                              {num_tr_code.toLocaleString()}
                               </td> 
                           </tr>
   
                           <tr>
                           <td className="text-start">
                           Opérations
                               </td>
                              <td  className="d-flex align-items-center gap-2">
                              
                              <button className="btn btn-warning btn-sm d-flex align-items-center"
                                                               >
                               <FaArrowDown size={20} style={{marginRight:'10px'}}
                               />
                                   Télécharger
                                  </button>
   
                                   <button className="btn btn-success btn-sm d-flex align-items-center"
                                   
                                                              onClick={() => navigate(`/vente/paiements/tr/enregistrement/${w_id}`,{
                                                                state: {
                                                                 id_vente: id_vente
                                                                } 
                                                               })}
                                                               >
                                           <AiOutlineCheckCircle size={20} style={{ marginRight: '5px' }} />
                                           Payé
                                           </button>
   
                               </td> 
                           </tr>
                           
                       </tbody>
                   </table>
             
           </div>
         </div>
       </div>
     );
   };

export default TrEnregistrement;
